import { createAction } from "@reduxjs/toolkit";

const REDUX_PROFILE_RESET_DATA = "profile/resetData";
const REDUX_PROFILE_SET_DATA = "profile/setData";
const REDUX_PROFILE_SET_INBOX_DOCUMENT_DATA = "profile/setInboxDocumentData";
const REDUX_PROFILE_SET_INBOX_TAX_SUMMARY_DATA = "profile/setInboxTaxSummaryData";

export const resetData = createAction(REDUX_PROFILE_RESET_DATA);
export const setData = createAction(REDUX_PROFILE_SET_DATA);
export const setInboxDocumentData = createAction(REDUX_PROFILE_SET_INBOX_DOCUMENT_DATA);
export const setInboxTaxSummaryData = createAction(REDUX_PROFILE_SET_INBOX_TAX_SUMMARY_DATA);